exports.default = {
  'copy_success': 'Copy {text} successful',
  'copy_failed': 'Copy {text} failed',
  'just_now': 'Just now',
  'minutes_ago': '{diff} minutes ago',
  'hours_ago': '{diff} hours ago',
  'yesterday': 'Yesterday',
  'month_day': '{month}/{date}',
  'sun': 'Sun',
  'mon': 'Mon',
  'tue': 'Tue',
  'wed': 'Wed',
  'thu': 'Thu',
  'fri': 'Fri',
  'sat': 'Sat',
  'year': 'Year',
  'month': 'Month',
  'day': 'Day',
  'login_invalid': 'Login invalid',
  'account_logged_elsewhere': 'Account has been logged in elsewhere!',
  'backend_exception': 'Backend API exception {code}',
  'network_connection_failed': 'Network connection failed, please check your network',
  'backend_request_timeout': 'Backend API request timeout',
  'backend_exception_code': 'Backend API exception {code}',
  'backend_unknown_exception': 'Backend API unknown exception'
}
